// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1nt18","signatureButtonsRight":"ModalSign_signatureButtonsRight__3vpwN"};